module.exports = __webpack_public_path__ + "img/bom-list_hover.8e7b2946.svg";